// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import { ua } from '../../../../../util/user-agent';
import { app } from '../../../../app';
import { Captcha } from '../../../../components/captcha/captcha.model';

app.controller('UsbTokenSamlLoginController', Controller);

/** @ngInject */
function Controller(
    $rootScope,
    $scope,
    $state,
    SamlLoginHandler
) {
    const appKey = $state.params.applicationId;
    const rememberMeKey = `saml-username-${appKey}-non-fido-usb`;
    $scope.username = localStorage.getItem(rememberMeKey);
    $scope.rememberMe = !!$scope.username;

    $scope.rememberMeChanged = () => {
        if (!$scope.rememberMe) {
            localStorage.removeItem(rememberMeKey);
        }
    };

    $rootScope.authenticationError = false;
    
    const captcha = $scope.captcha = new Captcha({
        isVisible: () => localStorage.getItem('loginAttempts') >= 3
    });
    
    $scope.login = function () {
        $rootScope.captchaError = false;
        $rootScope.authenticationError = false;
        SamlLoginHandler.login($scope.username, $scope.password, false, false, captcha.response, errorCallback);
        if ($scope.rememberMe) {
            localStorage.setItem(rememberMeKey, $scope.username);
        }
    };
    
    $scope.newLoginButton = ua.isAndroid() || ua.isIOS();
   
    // error callback function on login
    var errorCallback = function(response){
        var status = response.status;
        if (status == 412) {            
            $rootScope.captchaError = true;     
            $rootScope.captchaErrorMsg = 'login.messages.error.invalid_captcha';
        } else {
            $rootScope.authenticationError = true;
        }
        captcha.reset();
    }; 
}


// WEBPACK FOOTER //
// ./src/portal/states/public/login-web-saml/hard-token-login/usb-token-saml-login.controller.js